<template>
  <div v-cloak>
    <div v-if="loading">
      <b-spinner label="Loading..."></b-spinner>
    </div>
    <div v-else>

    <div id="profile">
      <b-card class="mb-3" header-tag="header" bg-variant="light" >
        <template v-slot:header>
          User <span style="float: right;"> <b-button variant="outline-dark"  size="sm" v-on:click.stop="logOut()">Sign out</b-button> </span>
        </template>
        <b-list-group>
          <b-list-group-item>{{ data.userPrincipalName }}</b-list-group-item>
          <b-list-group-item>{{ data.displayName }}</b-list-group-item>
          <b-list-group-item>{{ data.jobTitle }}</b-list-group-item>
          <b-list-group-item>{{ data.officeLocation }}</b-list-group-item>
          <b-list-group-item>{{ data.mail }}</b-list-group-item>
        </b-list-group>
      </b-card>

      <b-card header="Browser" bg-variant="light" >
        <b-list-group>
          <b-list-group-item>{{ browser.meta.name }} v{{ browser.meta.version }} </b-list-group-item>
          <b-list-group-item>{{ browser.meta.ua }}</b-list-group-item>
        </b-list-group>
      </b-card>

      <b-card header="Web App 2021.0" class="mt-3" bg-variant="light" no-body></b-card>

      <div id="button">
        <span>
        <div style="float: left;"><b-button v-show="isSysAdmin" v-on:click.stop="token()">Token</b-button></div>
        
        </span>
      </div>
    </div>

    <div id="token"  v-show="showToken">
      <b-card header="token" bg-variant="light" >
        {{ tokendata }}
      </b-card>
    </div>

  </div>

  </div>
</template>

<script>
export default {
  name: "Profile",
  methods: {
    logOut() {
      window.sessionStorage.clear();
      this.$auth.signOut();
    },
    token(){
     this.$auth.acquireToken().then(token => {
      this.tokendata = token;
      this.showToken = true;
    }); 
    },
    setSysAdmin() {
      this.$auth.acquireToken().then(token => {
        this.$http
          .get("api/IsAdmin/0000", {
            headers: { Authorization: "Bearer " + token }
          })
          .then(response => {
            this.isSysAdmin = response.data;
          })
          .catch(error => {
            console.log(error);
          });
      });
    }, 
    
    setBreadcrumb() {
      this.$store.setItem("breadcrumbs",[ 
      {
        text: 'Profile'
      }
      ]);
    }    
    
  },

  data: function() {
    return {
      data: null,
      tokendata: null,
      errored: false,
      error: null,
      loading: true,
      showToken: false,
      browser: null,
      isSysAdmin: false
    };
  },
  mounted: function() {
    this.loading = true;
    this.$auth.acquireGraphToken().then(token => {
      this.$http
      .get("v1.0/me/", {
          headers: { Authorization: "Bearer " + token },
          baseURL: "https://graph.microsoft.com/"
        })
        .then(response => {
          this.data = response.data;
        })
        .catch(error => {
          this.errored = true;
          this.error = error.response.statusText;
        })
        .finally(() => (this.loading = false));
    });
  },
   
   created: function(){
     this.browser = this.$browserDetect;
     this.setSysAdmin();
   },

  activated: function() {
    this.setBreadcrumb();
},

};
</script>

<style>
#profile {
  text-align: left;
  max-width: 500px;
  margin: 0 auto;
  padding-top: 40px;
}

#token {
  margin: 30px auto 0;
  max-width: 700px;
}

#button {
  padding: 30px;
}
</style>